var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInstructions)?_c('div',[_c('h4',[_vm._v("Instructions")]),_c('ul',_vm._l((_vm.instructions),function(instruction,index){return _c('li',{key:index},[_c('div',{domProps:{"innerHTML":_vm._s(instruction)}})])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }